import { render } from "./RiwayatPOModal.vue?vue&type=template&id=1ce06974&scoped=true"
import script from "./RiwayatPOModal.vue?vue&type=script&lang=js"
export * from "./RiwayatPOModal.vue?vue&type=script&lang=js"

import "./RiwayatPOModal.vue?vue&type=style&index=0&id=1ce06974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce06974"]])

export default __exports__